const staticRootUrl = "Static";

export default { staticRootUrl };
